import styled, { css } from 'styled-components';

export const NavElement = styled.nav`
  ${({ theme, ...props }) => {
    return css`
      padding: ${theme.spacing.base} 0 0;
    `;
  }};
`;

export const NavList = styled.ul`
  ${({ theme, ...props }) => {
    return css`
      //
    `;
  }};
`;

export const NavListItem = styled.li<{ active?: boolean }>`
  ${({ theme, active, ...props }) => {
    return css`
      margin: 0;
      padding: 0;
      list-style: none;
      border-radius: ${theme.radius.xs};
      &:hover,
      &.active {
        background: ${theme.color.secondary_100};
      }

      ${active &&
      css`
        background: ${theme.color.secondary_100};
      `};

      > a {
        display: flex;
        align-items: center;
        align-self: stretch;
        gap: 0.5rem;
        padding: 0.5rem;
        font-weight: ${theme.typography.font_weight.text_bold};
      }
    `;
  }};
`;
